import { useCallback } from 'preact/hooks'

import { Typography } from 'components'

import { updateTeamMemberCount, teamMemberCountState } from '../../../state'

const SeatsCounter = () => {
	const handleDecrease = useCallback(() => {
		updateTeamMemberCount(count => {
			if (count <= 1) return count

			return count - 1
		})
	}, [])

	const handleIncrease = useCallback(() => {
		updateTeamMemberCount(count => count + 1)
	}, [])

	return (
		<div>
			<Typography
				text='How many seats do you want to include?'
				variant='h4'
				weight='font-semibold'
			/>
			<Typography
				class='mt-2 text-black-200'
				text="You'll need additional seats to support your team. Remember, one is reserved for you."
				variant='text2'
			/>
			<div class='mt-5 flex items-center gap-4'>
				<div class='flex items-center rounded-md border border-solid border-[#313437]'>
					<button
						aria-label='Decrease seats'
						class='flex h-10 w-10 items-center justify-center rounded-bl-md rounded-tl-md bg-[#1F1F1F] text-black-100'
						onClick={handleDecrease}
						type='button'
					>
						–
					</button>
					<Typography
						class='w-10 text-center'
						text={teamMemberCountState.value.toString()}
						variant='h4'
					/>
					<button
						aria-label='Increase seats'
						class='flex h-10 w-10 items-center justify-center rounded-br-md rounded-tr-md bg-[#1F1F1F] text-black-100'
						onClick={handleIncrease}
						type='button'
					>
						+
					</button>
				</div>
			</div>
		</div>
	)
}

export { SeatsCounter }
